import load_html5_videos_controller from './load_html5_videos_controller'
import hls_loader from './hls_loader'
// todo: test all cases and see if they really still make sense

var stateMap = {
	isIOS: false,
	isTouchDevice: false,
}

// Pause any other unmuted, currently playing HTML5 videos when a new unmuted video starts
const pauseOtherUnmutedHtml5Videos = (currentVideo) => {
	const videos = document.querySelectorAll('.html5video video')
	videos.forEach((vid) => {
		if (vid !== currentVideo && vid.muted === false && vid.paused === false) {
			vid.pause()
		}
	})
}

// Attach global listeners so we keep unmuted playback mutually exclusive
const bindGlobalPauseOnUnmutedPlay = () => {
	// When a video starts playing and is unmuted, pause other unmuted videos
	document.addEventListener(
		'play',
		(event) => {
			const vid = event.target
			if (!(vid instanceof HTMLVideoElement)) {
				return
			}
			// only handle lay html5video elements
			if (!vid.closest('.html5video')) {
				return
			}
			if (vid.muted === false) {
				pauseOtherUnmutedHtml5Videos(vid)
			}
		},
		true
	)

	// When a playing video gets unmuted, pause other unmuted videos
	document.addEventListener(
		'volumechange',
		(event) => {
			const vid = event.target
			if (!(vid instanceof HTMLVideoElement)) {
				return
			}
			if (!vid.closest('.html5video')) {
				return
			}
			if (vid.muted === false && vid.paused === false) {
				pauseOtherUnmutedHtml5Videos(vid)
			}
		},
		true
	)
}

var html5video_controller = {
	i: function () {
		i()
	},
}

export default html5video_controller

var bindDelegatedEvents = function () {
	jQuery(document).on('click', '.lay-mute-unmute-button', function (e) {
		e.stopPropagation()
		e.preventDefault()
		jQuery(this).toggleClass('unmuted')
		var video = jQuery(this.parentNode).find('video')[0]
		video.muted = !video.muted

		// todo: test if this works:
		if (jQuery(this.parentNode).hasClass('video-slide') && video.muted == false) {
			// we're in a carousel. if we unmute one video, mute all others inside the carousel!
			var $otherUnmuteButtons = jQuery(this).closest('.lay-carousel').find('.lay-mute-unmute-button')
			var $thisUnmuteButton = jQuery(this)
			$otherUnmuteButtons.each(function () {
				// only stop and mute other videos
				if (!jQuery(this).is($thisUnmuteButton)) {
					jQuery(this).removeClass('unmuted')
					var video = jQuery(this.parentNode).find('video')[0]
					video.muted = true
				}
			})
		}
	})
}

var bindNewSingle = function ($scope) {
	const $root = $scope && $scope.length ? $scope : jQuery(document)
	$root.find('.html5video video').each(function () {
		var video = this
		var $playicon = jQuery(this.parentNode).find('.html5video-customplayicon')
		var $placeholder = jQuery(this.parentNode).find('.html5-video-placeholder-image')

		$playicon.on('click', function () {
			jQuery(video).one('canplay', function () {
				this.play()
			})
			load_html5_videos_controller.loadSpecificVideo(video)
			jQuery(video).addClass('userinteractedwith-playing')
			jQuery(video).removeClass('userinteractedwith-paused')
			jQuery(video).show()
			jQuery(video)[0].play()
			jQuery(this).hide()
			$placeholder.hide()
		})
	})

	$root.find('.html5video .html5-video-placeholder-image.playpauseonclick').each(function () {
		var video = jQuery(this.parentNode).find('video')[0]

		var $playicon = jQuery(this.parentNode).find('.html5video-customplayicon')

		jQuery(this).on('click', function () {
			jQuery(video).one('canplay', function () {
				this.play()
			})
			load_html5_videos_controller.loadSpecificVideo(video)
			jQuery(video).addClass('userinteractedwith-playing')
			jQuery(video).removeClass('userinteractedwith-paused')
			jQuery(video).show()
			jQuery(video)[0].play()
			jQuery(this).hide()
			$playicon.hide()
		})
	})

	var pausePlayOnClickTarget = '.html5video video.playpauseonclick'

	$root.find(pausePlayOnClickTarget).on('click', function () {
		if (this.paused) {
			jQuery(this).one('canplay', function () {
				this.play()
			})
			load_html5_videos_controller.loadSpecificVideo(this)
			this.play()
			jQuery(this.parentNode).find('.html5video-customplayicon').hide()
			this.classList.add('userinteractedwith-playing')
			jQuery(this).removeClass('userinteractedwith-paused')
		} else {
			this.pause()
			jQuery(this.parentNode).find('.html5video-customplayicon').show()
			jQuery(this).removeClass('userinteractedwith-playing')
			this.classList.add('userinteractedwith-paused')
		}
	})
}

// test if this still works
var normalizePlayOnMouseoverVideoThumbnails = function () {
	if (layData.video_thumbnail_mouseover_behaviour != 'play_on_mouseover') {
		return
	}

	// A touch-rendered layout can be reused from the shared layout cache on
	// desktop. Remove its autoplay state so the configured desktop mouseover
	// behaviour remains authoritative.
	jQuery('.thumb-rel video').each(function () {
		this.removeAttribute('autoplay')
		this.classList.remove('autoplay')
		this.pause()
	})
}

var bindPlayVideoThumbnailsOnMouseover = function () {
	if (layData.video_thumbnail_mouseover_behaviour == 'play_on_mouseover') {
		jQuery('body').on('mouseenter', '.thumb-rel', function () {
			var $vid = jQuery(this).find('video')
			if ($vid.length > 0) {
				jQuery($vid[0]).one('canplay', function () {
					this.play()
				})
				load_html5_videos_controller.loadSpecificVideo($vid[0])
				$vid[0].play()
			}
		})
		jQuery('body').on('mouseleave', '.thumb-rel', function () {
			var $vid = jQuery(this).find('video')
			if ($vid.length > 0) {
				$vid[0].pause()
			}
		})
	} else if (layData.video_thumbnail_mouseover_behaviour == 'pause_on_mouseover') {
		jQuery('body').on('mouseenter', '.thumb-rel', function () {
			var $vid = jQuery(this).find('video')
			if ($vid.length > 0) {
				$vid[0].pause()
			}
		})
		jQuery('body').on('mouseleave', '.thumb-rel', function () {
			var $vid = jQuery(this).find('video')
			if ($vid.length > 0) {
				jQuery($vid[0]).one('canplay', function () {
					this.play()
				})
				load_html5_videos_controller.loadSpecificVideo($vid[0])
				$vid[0].play()
			}
		})
	}
}

var i = function () {
	stateMap.isIOS = /iPad|iPhone|iPod/.test(navigator.platform)
	stateMap.isTouchDevice = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|playbook|silk|BlackBerry|BB10|Windows Phone|Tizen|Bada|webOS|IEMobile|Opera Mini)/)
	bindGlobalPauseOnUnmutedPlay()
	// Scope to event scope to avoid duplicate click handlers — bindNewSingle uses
	// .on('click', ...) without a paired .off(), so without scoping a future
	// double-fire (overlay + lazy underlay) would attach the play handler twice
	// to videos in the OTHER scope, doubling each click action.
	window.laytheme.on('newpageshown', function (layoutObj, type, obj, isProjectOverlayObj) {
		const isProjectOverlay = isProjectOverlayObj && isProjectOverlayObj.isProjectOverlay === true
		const $scope = isProjectOverlay ? jQuery('#lay-project-overlay > .lay-content') : jQuery('body > .lay-content')
		bindNewSingle($scope)
	})
	if (!stateMap.isTouchDevice) {
		normalizePlayOnMouseoverVideoThumbnails()
		bindPlayVideoThumbnailsOnMouseover()
		window.laytheme.on('newpageshown', function () {
			normalizePlayOnMouseoverVideoThumbnails()
		})
	}
	bindDelegatedEvents()
	hls_loader.init()
}
